import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import Scss
import "./assets/scss/themes.scss";

//import Route
import Route from "./Routes";

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";
import ScrollToTop from "./Components/Common/ScrollToTop";

// Activating fake backend
fakeBackend();

function App() {
  return (
    <React.Fragment>
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Routes */}
      <ScrollToTop />
      <Route />
    </React.Fragment>
  );
}

export default App;
